<template>
  <ion-page>
    <ion-content
      style="background: var(--client-bg-login-color) !important"
      class="ion-padding login-content"
      :class="bgClient"
    >
      <div class="flex-content">
        <img
          id="photo-fullscreen"
           :src="bgClient === 'bg-EstasiProfumerie' ? require('../assets/estasi_prof.png') : require('../assets/logo-whappy.png')"
          @error="handleImgError"
        />
      </div>
      <ion-card class="card-login">
        <!--        <ion-card-header>-->
        <!--          <ion-card-title>SignIn</ion-card-title>-->
        <!--        </ion-card-header>-->
        <ion-card-content>
          <div class="ion-no-padding">
            <label
              class="w-full text-18"
              style="color: var(--text-login-color) !important"
              position="stacked"
              >User Name</label
            >
            <ion-input
              class="w-full mt-2"
              @ionFocus="setFocusTrue"
              @ionBlur="setFocusFalse"
              inputmode="email"
              v-model="userInfo.username"
            ></ion-input>
          </div>
          <div class="ion-no-padding my-4 position-relative">
            <label
              class="w-full text-18"
              style="color: var(--text-login-color) !important"
              position="stacked"
              >Password</label
            >
            <ion-input
              class="w-full mt-2"
              @ionFocus="setFocusTrue"
              @ionBlur="setFocusFalse"
              :type="passwordVisible ? 'text' : 'password'"
              v-model="userInfo.password"
            ></ion-input>
            <div class="eye-icon">
              <ion-icon
                v-if="passwordVisible"
                tabindex="-1"
                @click="togglePasswordVisibility"
                :icon="eye"
              ></ion-icon>
              <ion-icon
                v-else
                tabindex="-1"
                @click="togglePasswordVisibility"
                :icon="eyeOff"
              ></ion-icon>
            </div>
          </div>

          <div class="w-full flex justify-content-center">
            <button
              class="button-login mt-4 w-full text-16"
              expand="full"
              :disabled="userInfo.username == '' || userInfo.password == ''"
              @click="login()"
            >
              Login
            </button>
          </div>
        </ion-card-content>
      </ion-card>
      <div id="bottom-component" class="bottom-component">
        <div v-if="tastieraFocus"></div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonCard,
  // IonCardHeader,
  // IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonContent,
  IonPage,
  IonIcon,
  toastController,
  loadingController,
  IonLoading,
} from "@ionic/vue";
import logo from '../assets/logo-whappy.png';
import { mapGetters, mapActions } from "vuex";
import { eye, eyeOff } from "ionicons/icons";

import UserService from "../common/mixins/User";

import VueCookies from "vue-cookies";
import { API_MOCK_ENABLE, API_MOCK_PATH, API_URL } from "../common/config";
import axios from "axios";
import { Plugins } from "@capacitor/core";
const { Storage } = Plugins;

export default {
  components: {
    IonCard,
    // IonCardHeader,
    // IonCardTitle,
    IonCardContent,
    IonContent,
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    IonButton,
    IonIcon,
    toastController,
  },
  mixins: [UserService],
  created() {
    this.removeDebugCookie();

    axios({
      // url: API_MOCK_PATH + 'setting.json',
      url: API_MOCK_ENABLE
        ? API_MOCK_PATH + "setting.json"
        : API_URL + "Setting",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((res) => {
      this.bgClient = "bg-" + res.data.ragione_sociale.replace(/\s/g, "");
    });
  },
  data() {
    return {
      bgClient: "",
      tastieraFocus: false,
      eye,
      eyeOff,
      passwordVisible: false,
      userInfo: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters("auth", {
      loginStatus: "getLoginStatus",
    }),
  },
  methods: {
    ...mapActions("auth", {
      loginUser: "loginUser",
    }),
    handleImgError() {
      return "https://placehold.co/300x300?text=MartechRevolution";
    },
    setFocusTrue() {
      this.tastieraFocus = true;
      this.scrollDown();
    },
    setFocusFalse() {
      this.tastieraFocus = false;
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    scrollDown() {
      document
        .querySelector("#bottom-component")
        .scrollIntoView({ behavior: "smooth" });
    },
    async showError() {
      const toast = await toastController.create({
        message: this.$t("login.error"),
        duration: 2000,
        color: "danger",
      });
      await toast.present();
    },
    async showOk() {
      const toast = await toastController.create({
        message: this.$t("login.success"),
        duration: 2000,
        color: "success",
      });
      await toast.present();
    },
    async login() {
      var md5 = require("md5");
      // Limpiar tokens corruptos antes de intentar login
      await this.cleanCorruptedTokens();
      this.presentLoading()
      if (this.settings.two_factor) {
        if (this.userInfo.username && this.userInfo.password) {
          let newPass = md5(this.userInfo.password);

          let newUserInfo = {
            username: this.userInfo.username,
            password: newPass,
            tfCode: "REQUEST",
          };
          try {
            await this.loginUser(newUserInfo);
            this.dismissLoading();
            this.showOk();
            this.$router.push({
              name: "ConfermaDueFattori",
              params: { username: this.userInfo.username, password: newPass },
            });
          } catch (e) {
            this.dismissLoading();
            this.showError();
          }
        }
      } else if (this.userInfo.username && this.userInfo.password) {
        let newPass = md5(this.userInfo.password);

        let newUserInfo = {
          username: this.userInfo.username,
          password: newPass,
        };
        try {
          await this.loginUser(newUserInfo);
          this.dismissLoading();
          this.showOk();
        } catch (e) {
          this.dismissLoading();
          this.showError();
        }
        if (this.loginStatus === "success") {
          this.getCurrentUser({ forceRefresh: true }).then((res) => {
  const companyId = res.data.id_company
  localStorage.setItem("companyId", companyId);
  this.dismissLoading();
  
  // Detección robusta del cliente Axerta para redirección
  const clientFromGlobal = (this.whappyClient || (this.whappyClientConfig && this.whappyClientConfig.name) || "").toString().toLowerCase();
  const clientEnv = (process.env.VUE_APP_WHAPPY_CLIENT || "").toLowerCase();
  const userData = res.data || {};
  
  console.log("Login: redirect decision ->", { 
    clientFromGlobal, 
    clientEnv, 
    companyId,
    whappyClientConfig: this.whappyClientConfig,
    userData: { id_company: userData.id_company, username: userData.username }
  });
  
  // Determinar si es Axerta (múltiples fuentes)
  const isAxerta = clientFromGlobal === "axerta" || clientEnv === "axerta";
  
  if (isAxerta) {
    console.log("Login: redirecting to /axerta/lista-ordini");
    this.$router.push("/axerta/lista-ordini");
  } else {
    console.log("Login: redirecting to /welcome");
    this.$router.push("/welcome");
  }
});} else {
          this.dismissLoading();
          this.showError();
        }
      }
    },
    async presentLoading() {
      console.log("presentLoading login");

      window.loadingCPresenting = true;
      if (!window.loadingC) {
        window.loadingC = await loadingController.create({
          spinner: null,
          cssClass: "login-custom-loading",
          message: "Stiamo caricando le tue campagne...",

          // duration: 60000,
        });
      }
      if (!window.loadingCPresented) {
        await window.loadingC.present();
        window.loadingCPresented = true;
      }
    },
    async dismissLoading() {
      if (window.loadingCPresented) {
        await window.loadingC.dismiss();
        window.loadingCPresenting = false;
        window.loadingCPresented = false;
        // // Sic
        // const elements = document.getElementsByClassName('my-custom-loading');
        // while(elements.length > 0){
        //   elements[0].parentNode.removeChild(elements[0]);
        // }
      } else if (window.loadingCPresenting) {
        setTimeout(() => {
          this.dismissLoading();
        }, 100);
      }
    },
    async cleanCorruptedTokens() {
      // Limpiar tokens potencialmente corruptos antes del login
      try {
        const { Storage } = await import("@capacitor/core").then(m => m.Plugins);
        await Storage.remove({ key: "access_token" });
        await Storage.remove({ key: "refresh_token" });
        console.log("Login: cleaned old tokens from storage");
      } catch (error) {
        console.error("Login: error cleaning tokens", error);
      }
    },
    removeDebugCookie() {
      console.log("debug mode:", VueCookies.get("debug"));
      VueCookies.remove("debug");
      console.log("debug mode:", VueCookies.get("debug"));
    },
  },
  watch: {
    isLoading: function (e) {
      if (e) {
        this.presentLoading();
      } else {
        this.dismissLoading();
      }
    },
  },
};
</script>
<style scoped lang="scss">
ion-card {
  box-shadow: none;
}
.flex-content {
  margin: 0px auto;
  width: 100%;
  height: calc(100% - 400px);
  display: flex; /* Magic begins */
  flex-direction: column;
  justify-content: center; /* Center in main axis */
  align-items: center; /* Center in cross axis */
}

#photo-fullscreen {
  max-width: 100%;
  max-height: calc(100% - 100px);
}

.position-relative {
  position: relative;
}

.eye-icon {
  position: absolute;
  bottom: 3px;
  right: 17px;
  color: rgb(255, 255, 255);

  z-index: 2;
}
ion-icon {
  font-size: 2rem;
}

ion-item::part(native) {
  background-color: rgba(255, 255, 255, 0);
  color: var(--text-color-light);
  border-radius: 5px;
}

.label-stacked {
  font-size: 1.7rem;
  color: var(--client-color-text-button) !important;
  margin-bottom: 1rem;
}

ion-input {
  width: 97%;
  font-size: 1.2rem;
}

ion-button::part(native) {
  margin-top: 4rem;
  background-color: #fff;
  background-color: var(--ion-color-secondary);
  color: var(--client-color-text-button);
  font-size: 2rem !important;
  text-transform: none;
  border-radius: 0px;
  padding: 0.6rem 2rem;
  font-weight: bolder;
}

.bottom-component {
  width: 100%;
  padding-top: 50vh;
}

.bg-Axerta {
  --background: url("https://axerta.whappy.it/img/axerta_bg.jpg") no-repeat
    center center / cover;
}

.bg-YoubeCosmetics {
  --background: var(--client-ground1-color);
  ion-item[data-v-26084dc2]::part(native) {
    color: var(--ion-color-primary);
  }

  ion-icon {
    color: var(--ion-color-primary);
  }
}

.bg-CommercialProjectManagement {
  --background: var(--ion-color-primary);
}

ion-input {
  --background: #faf1ef;
  color: var(--ion-color-primary);
  width: 100%;
}
</style>
